import React, { useEffect, useCallback, useState } from "react";
import styles from "./Library.module.scss";
import SavedList from "../../components/Library/SavedList";
import CategoryGrid from "../../components/Library/CategoryGrid";
import { useDispatch, useSelector } from "react-redux";
import { fetchSavedNewsByUser } from "../../Reducers/actions/newsActions";
import { fetchSavedCreationsByUser, fetchLibraryCreations } from "../../Reducers/actions/creationsActions";
import { fetchRecentlyPurchased } from "../../Reducers/actions/ordersActions";
import { usePullToRefresh } from "../../../hooks/usePullToRefresh";
import { cachingService } from "../../../helpers/cache";
import Icon from "../../components/Icon/Icon";
// import { fetchAllOrderedCategories } from "../../Reducers/actions/ordersActions";

function Library() {
  const dispatch = useDispatch();
  const [firstLoad, setFirstLoad] = useState(false);

  const {
    userId,
    savedCreations,
    savedNews,
    // fetchSavedNews,
    // fetchSavedCreations,
    savedNewsLoading,
    savedCreationsLoading,
    recentlyPurchasedLoading,
    libraryCreationsLoading,
    // categories,
    // categoriesLoading, 
    recentlyPurchased,
    libraryCreations,
  } = useSelector((state) => ({
    userId: state?.auth?.session?.user?.id,
    savedNews: state?.news?.savedNews,
    savedNewsLoading: state?.news?.loading,
    savedCreations: state?.creation?.savedCreations,
    savedCreationsLoading: state?.creation?.loading,
    // fetchSavedNews: state?.news?.fetchSaved,
    // fetchSavedCreations: state?.creation?.fetchSaved,loading_recently_purchased
    recentlyPurchased: state?.orders?.recently_purchased,
    recentlyPurchasedLoading: state?.orders?.loading_recently_purchased,
    libraryCreations: state?.creation?.libraryCreations,
    libraryCreationsLoading: state?.creation?.loadingLibrary
  }));

  const isLoading = savedNewsLoading || savedCreationsLoading || recentlyPurchasedLoading || libraryCreationsLoading;

  // Pull-to-refresh handler
  const handleRefresh = useCallback(async () => {
    if (!userId) return;
    
    try {
      // Clear cache to force fresh fetch
      cachingService.invalidate(['/api/library'], true);
      cachingService.invalidate(['/api/orders'], true);
      
      // Fetch all library data
      await Promise.all([
        dispatch(fetchSavedNewsByUser(userId)),
        dispatch(fetchSavedCreationsByUser(userId)),
        dispatch(fetchRecentlyPurchased(10)),
        dispatch(fetchLibraryCreations(1, 10))
      ]);
    } catch (error) {
      console.error('Error refreshing library:', error);
    }
  }, [dispatch, userId]);

  // Pull-to-refresh hook
  const { containerRef, isRefreshing, pullDistance, pullProgress, shouldTrigger, shouldShowIndicator } = usePullToRefresh(
    handleRefresh,
    { 
      threshold: 80, 
      disabled: isLoading || !firstLoad || !userId 
    }
  );

  useEffect(() => {
    if (userId) {
      Promise.all([
        dispatch(fetchSavedNewsByUser(userId)),
        dispatch(fetchSavedCreationsByUser(userId)),
        dispatch(fetchRecentlyPurchased(10)),
        dispatch(fetchLibraryCreations(1, 10))
      ]).then(() => {
        setFirstLoad(true);
      });
    }
  }, [dispatch, userId]);



  return (
    <div className={styles.libraryContainer} ref={containerRef}>
      {/* Pull-to-refresh indicator */}
      {(shouldShowIndicator || isRefreshing || shouldTrigger) && (
        <div 
          className="pull-to-refresh-indicator"
          style={{
            transform: `translateY(${Math.min(pullDistance, 1)}px)`,
            opacity: Math.min(pullProgress, 1)
          }}
        >
          <div className="pull-to-refresh-spinner">
            {isRefreshing ? (
              <div className="spinner" />
            ) : (
              <Icon 
                alias="chevron-down" 
                width={24} 
                color="#FF3232"
                style={{
                  transform: `rotate(${shouldTrigger ? 180 : 0}deg)`,
                  transition: 'transform 0.2s ease'
                }}
              />
            )}
          </div>
          <p className="pull-to-refresh-text">
            {isRefreshing ? 'Refreshing...' : shouldTrigger ? 'Release to refresh' : 'Pull to refresh'}
          </p>
        </div>
      )}
      
      <CategoryGrid categories={[]} />


      {(
        <SavedList
          key={'purchased'}
          title="Recently purchased"
          items={(recentlyPurchased?.length > 0) ? recentlyPurchased.map((item) => item) : []}
          type="recently-purchased"
          loading={recentlyPurchasedLoading}

        />
      )}
      {(
        <SavedList
          key={'added'}
          title="Recently added"
          items={libraryCreations?.length > 0 ? libraryCreations : []}
          type="my"
          loading={libraryCreationsLoading}

        />
      )}
      {(
        <SavedList
          key={'saved-creations'}
          title="Favourite Creations"
          items={savedCreations?.length > 0 ? savedCreations : []}
          type="creations"
          loading={savedCreationsLoading}

        />
      )}
      {(
        <SavedList
          key={'saved-news'}
          title="Favourite News"
          items={savedNews?.length > 0 ? savedNews : []}
          type="news"
          loading={savedNewsLoading}
        />
      )}
    </div>
  );
}

export default Library